module.exports = __webpack_public_path__ + "media/bgm_out_game.4a5ab83f.mp3";